export const isProduction = (
	String(BUILD) === 'production'
    || window.location.hostname === 'new-crm-prod.ukc.loc'
);